import {Button, Dialog, DialogActions, DialogContent} from "@mui/material";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContentText from "@mui/material/DialogContentText";
import { deleteDocumentsRs, getDocumentsRs } from "../../../../search-repair-shop/rsSearch.actions";
import { snackbarTypes } from "../../../../../../util/state/globalVariables";
import { setSnackbar } from "../../../../../../util/state/globalAction";
import { useContext } from "react";
import { GlobalContext } from "../../../../../../util/state/GlobalContextProvider";
import { useSetRecoilState } from "recoil";
import { documentsRsState } from "../../../../search-repair-shop/state";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

const DeleteFileDialog = ({deleteFile, setDeleteFile}: any) => {
    const {dispatchGlobalData} = useContext(GlobalContext);
    const setDocumentRs = useSetRecoilState(documentsRsState);
    const {id} = useParams();
    const {t} = useTranslation(['network', 'translation']);

    const handleExit = () => setDeleteFile(null);

    const deleteHandler = () => {
        deleteDocumentsRs({idDoc: deleteFile?.idDoc})
        .then((res: any) => {
            getDocumentsRs({id})
            .then((res: any) => {
                setDocumentRs(res?.document);
            })
            .catch(() => {
                dispatchGlobalData({
                    type: setSnackbar,
                    payload: {
                        snackbar: {
                            message: t('error.tryLater'),
                            type: snackbarTypes.error,
                            show: true,
                            autoClose: true,
                        }
                    }
                });
            })
            .finally(() => {
                handleExit()
            });
        })
    }

    return (
        <Dialog
            open={deleteFile !== null}
            onClose={handleExit}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {t("rsDetail.documentRepositoryDms.dialog.titleRemove")}
            </DialogTitle>

            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {t('rsDetail.documentRepositoryDms.dialog.removeBody', {fileName: deleteFile?.fileName})}
                </DialogContentText>
            </DialogContent>

            <DialogActions>
                <Button variant="outlined" onClick={handleExit}>
                    {t("rsDetail.documentRepositoryDms.dialog.action.cancel")}
                </Button>
                <Button onClick={() => deleteHandler()} autoFocus>
                    {t("rsDetail.documentRepositoryDms.dialog.action.remove")}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default DeleteFileDialog;
